import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const STORAGE_KEY = 'cookie_consent_v1';
export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    try {
      const accepted = localStorage.getItem(STORAGE_KEY);
      if (!accepted) {
        const t = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(t);
      }
    } catch {
      setVisible(true);
    }
  }, []);
  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        accepted: true,
        at: new Date().toISOString()
      }));
    } catch {}
    setVisible(false);
  };
  return <AnimatePresence data-id="element-39">
      {visible && <motion.div initial={{
      y: 20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 20,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: [0.21, 0.47, 0.32, 0.98]
    }} className="fixed bottom-3 left-3 right-3 md:bottom-4 md:left-1/2 md:right-auto md:-translate-x-1/2 md:max-w-2xl z-[90]" role="dialog" aria-live="polite" aria-label="Уведомление об использовании файлов cookie" data-id="element-40">
          <div className="bg-white/95 backdrop-blur-sm border border-beige rounded-xl shadow-soft px-4 py-3 flex items-center gap-3" data-id="element-41">
            <p className="text-[12px] text-navyLight leading-snug flex-1" data-id="element-42">
              Мы используем cookie для аналитики. Продолжая, вы соглашаетесь с{' '}
              <a href="#/privacy" className="text-navy underline hover:text-sage transition-colors" data-id="element-43">
                политикой
              </a>
              .
            </p>
            <button onClick={accept} className="shrink-0 text-[12px] font-medium text-sage hover:text-sageDark transition-colors px-2 py-1" data-id="element-44">
              Принимаю
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
};